/* External dependencies */
import { Observable } from 'rxjs';
import { debounceTime, filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../../../clients/client';
import { isAdminOrManager } from '../../../../common/helpers';
import { SessionUser } from '../../../auth/redux/auth-actions';
import { listOrdersError, listOrdersSuccess } from './actions';
import { listOrdersQuery, listPersonalOrdersQuery } from './queries';
import { ListOrdersAction, ListOrdersActionTypes, ListOrdersRequest, ListOrdersSuccess } from './types';

export default function listOrdersEpic(action$: Observable<ListOrdersAction>, state$) {
  return action$.pipe(
    filter((action: ListOrdersRequest) => action.type === ListOrdersActionTypes.LIST_ORDERS_REQUEST),
    debounceTime(800),
    switchMap((action: ListOrdersRequest) => listOrders(action, state$.value.auth.currentUser).catch(listOrdersError)),
  );
}

export async function listOrders(options: ListOrdersRequest, currentUser: SessionUser): Promise<ListOrdersSuccess> {
  const { query, filter, currentPage, size } = options;

  if (!currentUser?.sub) {
    throw new Error('Cannot list orders before the current user session is initialized');
  }

  const graphQLClient = await getClient();
  const requestFilter = { ...filter };
  const canViewUserDetails = isAdminOrManager(currentUser);

  if (!canViewUserDetails) {
    requestFilter.userId = currentUser.sub;
  }

  const {
    data: {
      listOrders: { total, orders },
    },
  } = await graphQLClient.query({
    query: canViewUserDetails ? listOrdersQuery : listPersonalOrdersQuery,
    variables: {
      input: {
        query,
        filter: requestFilter,
        from: (currentPage - 1) * size,
        size,
      },
    },
  });

  return listOrdersSuccess(total, orders);
}
